module.exports = __webpack_public_path__ + "static/media/header-mobile.10b44528.png";